import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/flexbox/flexbox.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
